import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { HelperThreeDotsMenuModule } from '../../helpers/navigation/three-dots-menu/three-dots-menu.module';

import { CoreVersionSharesMainComponent } from './main/main.component';
import { CoreVersionSharesItemComponent} from './item/item.component';
import { CoreVersionSharesStatusListComponent} from './status-list/status-list.component';

@NgModule({
    imports: [
        CommonModule,
        HelpersModule,
        HelperThreeDotsMenuModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        CoreVersionSharesMainComponent,
        CoreVersionSharesItemComponent,
        CoreVersionSharesStatusListComponent
    ],
    exports: [
        CoreVersionSharesMainComponent,
        CoreVersionSharesStatusListComponent
    ],

})
export class CoreVersionSharesModule { }


